/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { JsonNode } from '../models/json-node';
import { BranchDTO } from '../models/branch-dto';
import { ResourceFileRequest } from '../models/resource-file-request';
import { ResourceRenameRequest } from '../models/resource-rename-request';
import { ResourceEnableDisableRequest } from '../models/resource-enable-disable-request';
import { ModuleInputDTO } from '../models/module-input-dto';
import { ListPullRequestResponse } from '../models/list-pull-request-response';
import { AutocompleteResponse } from '../models/autocomplete-response';
import { AutocompleteResponseV2 } from '../models/autocomplete-response-v2';
import { AddOnDTO } from '../models/add-on-dto';
import { ListWorkflowRunsResponse } from '../models/list-workflow-runs-response';
import { Workflow } from '../models/workflow';
import { VariableDetails } from '../models/variable-details';
import { BlueprintFile } from '../models/blueprint-file';

/**
 * Ui Blueprint Designer Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiBlueprintDesignerControllerService extends __BaseService {
  static readonly getSchemaMetadataUsingGETPath =
    '/cc-ui/v1/designer/facets-components';
  static readonly listBranchesUsingGETPath =
    '/cc-ui/v1/designer/{stackName}/branch-list';
  static readonly createResourcesUsingPOSTPath =
    '/cc-ui/v1/designer/{stackName}/branch/{branch}';
  static readonly updateResourcesUsingPUTPath =
    '/cc-ui/v1/designer/{stackName}/branch/{branch}';
  static readonly deleteResourcesUsingDELETEPath =
    '/cc-ui/v1/designer/{stackName}/branch/{branch}';
  static readonly renameResourceUsingPUTPath =
    '/cc-ui/v1/designer/{stackName}/branch/{branch}/rename';
  static readonly bulkEditDisabledForResourcesUsingPUTPath =
    '/cc-ui/v1/designer/{stackName}/branch/{branch}/resource-enable-disable';
  static readonly getModuleInputsUsingGETPath =
    '/cc-ui/v1/designer/{stackName}/intent/{intent}/flavor/{flavor}/input';
  static readonly getPullRequestsUsingGETPath =
    '/cc-ui/v1/designer/{stackName}/pulls';
  static readonly getAutocompleteDataUsingGETPath =
    '/cc-ui/v1/designer/{stackName}/ref-autocomplete-data';
  static readonly getAutocompleteDataV2UsingGETPath =
    '/cc-ui/v1/designer/{stackName}/ref-autocomplete-data-v2';
  static readonly bulkEditDisabledForResourcesUsingPUT1Path =
    '/cc-ui/v1/designer/{stackName}/resource-enable-disable';
  static readonly getAddOnModulesUsingGETPath =
    '/cc-ui/v1/designer/{stackName}/resourceType/{resourceType}/resourceName/{resourceName}/add-ons';
  static readonly listBranchesUsingGET1Path =
    '/cc-ui/v1/designer/{stackName}/resourceType/{resourceType}/resourceName/{resourceName}/branch-list';
  static readonly getPullRequestsUsingGET1Path =
    '/cc-ui/v1/designer/{stackName}/resourceType/{resourceType}/resourceName/{resourceName}/pulls';
  static readonly getWorkflowRunsUsingGETPath =
    '/cc-ui/v1/designer/{stackName}/resourceType/{resourceType}/resourceName/{resourceName}/workflow-runs';
  static readonly getWorkflowsUsingGETPath =
    '/cc-ui/v1/designer/{stackName}/resourceType/{resourceType}/resourceName/{resourceName}/workflows';
  static readonly addVariablesUsingPOSTPath =
    '/cc-ui/v1/designer/{stackName}/variables';
  static readonly updateVariablesUsingPUTPath =
    '/cc-ui/v1/designer/{stackName}/variables';
  static readonly deleteVariablesUsingDELETEPath =
    '/cc-ui/v1/designer/{stackName}/variables';
  static readonly getWorkflowRunsUsingGET1Path =
    '/cc-ui/v1/designer/{stackName}/workflow-runs';
  static readonly getWorkflowsUsingGET1Path =
    '/cc-ui/v1/designer/{stackName}/workflows';
  static readonly getDesignerResourcesUsingGETPath =
    '/cc-ui/v1/designer/{stackName}/{branchName}/files';
  static readonly createBranchUsingPOSTPath =
    '/cc-ui/v1/designer/{stackName}/{branch}/create-branch';
  static readonly applyTemplateUsingPOSTPath =
    '/cc-ui/v1/designer/{stackName}/{templateName}/apply';
  static readonly syncSpecifiedBlueprintsWithTemplatesUsingPOSTPath =
    '/cc-ui/v1/designer/{templateName}/sync';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getSchemaMetadata
   * @return OK
   */
  getSchemaMetadataUsingGETResponse(): __Observable<
    __StrictHttpResponse<JsonNode>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/designer/facets-components`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<JsonNode>;
      }),
    );
  }
  /**
   * getSchemaMetadata
   * @return OK
   */
  getSchemaMetadataUsingGET(): __Observable<JsonNode> {
    return this.getSchemaMetadataUsingGETResponse().pipe(
      __map((_r) => _r.body as JsonNode),
    );
  }

  /**
   * listBranches
   * @param stackName stackName
   * @return OK
   */
  listBranchesUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<BranchDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(stackName),
        )}/branch-list`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BranchDTO>;
      }),
    );
  }
  /**
   * listBranches
   * @param stackName stackName
   * @return OK
   */
  listBranchesUsingGET(stackName: string): __Observable<BranchDTO> {
    return this.listBranchesUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as BranchDTO),
    );
  }

  /**
   * createResources
   * @param params The `UiBlueprintDesignerControllerService.CreateResourcesUsingPOSTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceFileRequests`: resourceFileRequests
   *
   * - `branch`: branch
   */
  createResourcesUsingPOSTResponse(
    params: UiBlueprintDesignerControllerService.CreateResourcesUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.resourceFileRequests;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/branch/${encodeURIComponent(String(params.branch))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * createResources
   * @param params The `UiBlueprintDesignerControllerService.CreateResourcesUsingPOSTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceFileRequests`: resourceFileRequests
   *
   * - `branch`: branch
   */
  createResourcesUsingPOST(
    params: UiBlueprintDesignerControllerService.CreateResourcesUsingPOSTParams,
  ): __Observable<null> {
    return this.createResourcesUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * updateResources
   * @param params The `UiBlueprintDesignerControllerService.UpdateResourcesUsingPUTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceFileRequests`: resourceFileRequests
   *
   * - `branch`: branch
   */
  updateResourcesUsingPUTResponse(
    params: UiBlueprintDesignerControllerService.UpdateResourcesUsingPUTParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.resourceFileRequests;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/branch/${encodeURIComponent(String(params.branch))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * updateResources
   * @param params The `UiBlueprintDesignerControllerService.UpdateResourcesUsingPUTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceFileRequests`: resourceFileRequests
   *
   * - `branch`: branch
   */
  updateResourcesUsingPUT(
    params: UiBlueprintDesignerControllerService.UpdateResourcesUsingPUTParams,
  ): __Observable<null> {
    return this.updateResourcesUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * deleteResources
   * @param params The `UiBlueprintDesignerControllerService.DeleteResourcesUsingDELETEParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceFileRequests`: resourceFileRequests
   *
   * - `branch`: branch
   */
  deleteResourcesUsingDELETEResponse(
    params: UiBlueprintDesignerControllerService.DeleteResourcesUsingDELETEParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.resourceFileRequests;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/branch/${encodeURIComponent(String(params.branch))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * deleteResources
   * @param params The `UiBlueprintDesignerControllerService.DeleteResourcesUsingDELETEParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceFileRequests`: resourceFileRequests
   *
   * - `branch`: branch
   */
  deleteResourcesUsingDELETE(
    params: UiBlueprintDesignerControllerService.DeleteResourcesUsingDELETEParams,
  ): __Observable<null> {
    return this.deleteResourcesUsingDELETEResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * renameResource
   * @param params The `UiBlueprintDesignerControllerService.RenameResourceUsingPUTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceRenameRequest`: resourceRenameRequest
   *
   * - `branch`: branch
   */
  renameResourceUsingPUTResponse(
    params: UiBlueprintDesignerControllerService.RenameResourceUsingPUTParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.resourceRenameRequest;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/branch/${encodeURIComponent(String(params.branch))}/rename`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * renameResource
   * @param params The `UiBlueprintDesignerControllerService.RenameResourceUsingPUTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceRenameRequest`: resourceRenameRequest
   *
   * - `branch`: branch
   */
  renameResourceUsingPUT(
    params: UiBlueprintDesignerControllerService.RenameResourceUsingPUTParams,
  ): __Observable<null> {
    return this.renameResourceUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * bulkEditDisabledForResources
   * @param params The `UiBlueprintDesignerControllerService.BulkEditDisabledForResourcesUsingPUTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceEnableDisableRequestList`: resourceEnableDisableRequestList
   *
   * - `branch`: branch
   */
  bulkEditDisabledForResourcesUsingPUTResponse(
    params: UiBlueprintDesignerControllerService.BulkEditDisabledForResourcesUsingPUTParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.resourceEnableDisableRequestList;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/branch/${encodeURIComponent(
          String(params.branch),
        )}/resource-enable-disable`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * bulkEditDisabledForResources
   * @param params The `UiBlueprintDesignerControllerService.BulkEditDisabledForResourcesUsingPUTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceEnableDisableRequestList`: resourceEnableDisableRequestList
   *
   * - `branch`: branch
   */
  bulkEditDisabledForResourcesUsingPUT(
    params: UiBlueprintDesignerControllerService.BulkEditDisabledForResourcesUsingPUTParams,
  ): __Observable<null> {
    return this.bulkEditDisabledForResourcesUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * getModuleInputs
   * @param params The `UiBlueprintDesignerControllerService.GetModuleInputsUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `intent`: intent
   *
   * - `flavor`: flavor
   *
   * @return OK
   */
  getModuleInputsUsingGETResponse(
    params: UiBlueprintDesignerControllerService.GetModuleInputsUsingGETParams,
  ): __Observable<__StrictHttpResponse<{ [key: string]: ModuleInputDTO }>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/intent/${encodeURIComponent(
          String(params.intent),
        )}/flavor/${encodeURIComponent(String(params.flavor))}/input`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{ [key: string]: ModuleInputDTO }>;
      }),
    );
  }
  /**
   * getModuleInputs
   * @param params The `UiBlueprintDesignerControllerService.GetModuleInputsUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `intent`: intent
   *
   * - `flavor`: flavor
   *
   * @return OK
   */
  getModuleInputsUsingGET(
    params: UiBlueprintDesignerControllerService.GetModuleInputsUsingGETParams,
  ): __Observable<{ [key: string]: ModuleInputDTO }> {
    return this.getModuleInputsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as { [key: string]: ModuleInputDTO }),
    );
  }

  /**
   * getPullRequests
   * @param params The `UiBlueprintDesignerControllerService.GetPullRequestsUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `state`: state
   *
   * - `query`: query
   *
   * - `pageSize`: pageSize
   *
   * - `pageNumber`: pageNumber
   *
   * - `createdDate`: createdDate
   *
   * @return OK
   */
  getPullRequestsUsingGETResponse(
    params: UiBlueprintDesignerControllerService.GetPullRequestsUsingGETParams,
  ): __Observable<__StrictHttpResponse<ListPullRequestResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.state != null)
      __params = __params.set('state', params.state.toString());
    if (params.query != null)
      __params = __params.set('query', params.query.toString());
    if (params.pageSize != null)
      __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set('pageNumber', params.pageNumber.toString());
    if (params.createdDate != null)
      __params = __params.set('createdDate', params.createdDate.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/pulls`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListPullRequestResponse>;
      }),
    );
  }
  /**
   * getPullRequests
   * @param params The `UiBlueprintDesignerControllerService.GetPullRequestsUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `state`: state
   *
   * - `query`: query
   *
   * - `pageSize`: pageSize
   *
   * - `pageNumber`: pageNumber
   *
   * - `createdDate`: createdDate
   *
   * @return OK
   */
  getPullRequestsUsingGET(
    params: UiBlueprintDesignerControllerService.GetPullRequestsUsingGETParams,
  ): __Observable<ListPullRequestResponse> {
    return this.getPullRequestsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as ListPullRequestResponse),
    );
  }

  /**
   * getAutocompleteData
   * @param stackName stackName
   * @return OK
   */
  getAutocompleteDataUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<AutocompleteResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(stackName),
        )}/ref-autocomplete-data`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AutocompleteResponse>;
      }),
    );
  }
  /**
   * getAutocompleteData
   * @param stackName stackName
   * @return OK
   */
  getAutocompleteDataUsingGET(
    stackName: string,
  ): __Observable<AutocompleteResponse> {
    return this.getAutocompleteDataUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as AutocompleteResponse),
    );
  }

  /**
   * Get autocomplete data with module-specific output trees
   *
   * Returns module-specific output trees for each resource with automatic fallback to intent-level outputs
   * @param stackName stackName
   * @return OK
   */
  getAutocompleteDataV2UsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<AutocompleteResponseV2>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(stackName),
        )}/ref-autocomplete-data-v2`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AutocompleteResponseV2>;
      }),
    );
  }
  /**
   * Get autocomplete data with module-specific output trees
   *
   * Returns module-specific output trees for each resource with automatic fallback to intent-level outputs
   * @param stackName stackName
   * @return OK
   */
  getAutocompleteDataV2UsingGET(
    stackName: string,
  ): __Observable<AutocompleteResponseV2> {
    return this.getAutocompleteDataV2UsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as AutocompleteResponseV2),
    );
  }

  /**
   * bulkEditDisabledForResources
   * @param params The `UiBlueprintDesignerControllerService.BulkEditDisabledForResourcesUsingPUT1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceEnableDisableRequestList`: resourceEnableDisableRequestList
   */
  bulkEditDisabledForResourcesUsingPUT1Response(
    params: UiBlueprintDesignerControllerService.BulkEditDisabledForResourcesUsingPUT1Params,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.resourceEnableDisableRequestList;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/resource-enable-disable`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * bulkEditDisabledForResources
   * @param params The `UiBlueprintDesignerControllerService.BulkEditDisabledForResourcesUsingPUT1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceEnableDisableRequestList`: resourceEnableDisableRequestList
   */
  bulkEditDisabledForResourcesUsingPUT1(
    params: UiBlueprintDesignerControllerService.BulkEditDisabledForResourcesUsingPUT1Params,
  ): __Observable<null> {
    return this.bulkEditDisabledForResourcesUsingPUT1Response(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * Get add ons for this resource
   * @param params The `UiBlueprintDesignerControllerService.GetAddOnModulesUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `cloud`: cloud
   *
   * @return OK
   */
  getAddOnModulesUsingGETResponse(
    params: UiBlueprintDesignerControllerService.GetAddOnModulesUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<AddOnDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.cloud != null)
      __params = __params.set('cloud', params.cloud.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/resourceType/${encodeURIComponent(
          String(params.resourceType),
        )}/resourceName/${encodeURIComponent(
          String(params.resourceName),
        )}/add-ons`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AddOnDTO>>;
      }),
    );
  }
  /**
   * Get add ons for this resource
   * @param params The `UiBlueprintDesignerControllerService.GetAddOnModulesUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `cloud`: cloud
   *
   * @return OK
   */
  getAddOnModulesUsingGET(
    params: UiBlueprintDesignerControllerService.GetAddOnModulesUsingGETParams,
  ): __Observable<Array<AddOnDTO>> {
    return this.getAddOnModulesUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<AddOnDTO>),
    );
  }

  /**
   * listBranches
   * @param params The `UiBlueprintDesignerControllerService.ListBranchesUsingGET1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * @return OK
   */
  listBranchesUsingGET1Response(
    params: UiBlueprintDesignerControllerService.ListBranchesUsingGET1Params,
  ): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/resourceType/${encodeURIComponent(
          String(params.resourceType),
        )}/resourceName/${encodeURIComponent(
          String(params.resourceName),
        )}/branch-list`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * listBranches
   * @param params The `UiBlueprintDesignerControllerService.ListBranchesUsingGET1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * @return OK
   */
  listBranchesUsingGET1(
    params: UiBlueprintDesignerControllerService.ListBranchesUsingGET1Params,
  ): __Observable<Array<string>> {
    return this.listBranchesUsingGET1Response(params).pipe(
      __map((_r) => _r.body as Array<string>),
    );
  }

  /**
   * getPullRequests
   * @param params The `UiBlueprintDesignerControllerService.GetPullRequestsUsingGET1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `state`: state
   *
   * - `query`: query
   *
   * - `pageSize`: pageSize
   *
   * - `pageNumber`: pageNumber
   *
   * - `createdDate`: createdDate
   *
   * @return OK
   */
  getPullRequestsUsingGET1Response(
    params: UiBlueprintDesignerControllerService.GetPullRequestsUsingGET1Params,
  ): __Observable<__StrictHttpResponse<ListPullRequestResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.state != null)
      __params = __params.set('state', params.state.toString());
    if (params.query != null)
      __params = __params.set('query', params.query.toString());
    if (params.pageSize != null)
      __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set('pageNumber', params.pageNumber.toString());
    if (params.createdDate != null)
      __params = __params.set('createdDate', params.createdDate.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/resourceType/${encodeURIComponent(
          String(params.resourceType),
        )}/resourceName/${encodeURIComponent(
          String(params.resourceName),
        )}/pulls`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListPullRequestResponse>;
      }),
    );
  }
  /**
   * getPullRequests
   * @param params The `UiBlueprintDesignerControllerService.GetPullRequestsUsingGET1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `state`: state
   *
   * - `query`: query
   *
   * - `pageSize`: pageSize
   *
   * - `pageNumber`: pageNumber
   *
   * - `createdDate`: createdDate
   *
   * @return OK
   */
  getPullRequestsUsingGET1(
    params: UiBlueprintDesignerControllerService.GetPullRequestsUsingGET1Params,
  ): __Observable<ListPullRequestResponse> {
    return this.getPullRequestsUsingGET1Response(params).pipe(
      __map((_r) => _r.body as ListPullRequestResponse),
    );
  }

  /**
   * getWorkflowRuns
   * @param params The `UiBlueprintDesignerControllerService.GetWorkflowRunsUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `workflowId`: workflowId
   *
   * - `status`: status
   *
   * - `pageSize`: pageSize
   *
   * - `pageNumber`: pageNumber
   *
   * - `event`: event
   *
   * - `branch`: branch
   *
   * - `actor`: actor
   *
   * @return OK
   */
  getWorkflowRunsUsingGETResponse(
    params: UiBlueprintDesignerControllerService.GetWorkflowRunsUsingGETParams,
  ): __Observable<__StrictHttpResponse<ListWorkflowRunsResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.workflowId != null)
      __params = __params.set('workflowId', params.workflowId.toString());
    if (params.status != null)
      __params = __params.set('status', params.status.toString());
    if (params.pageSize != null)
      __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set('pageNumber', params.pageNumber.toString());
    if (params.event != null)
      __params = __params.set('event', params.event.toString());
    if (params.branch != null)
      __params = __params.set('branch', params.branch.toString());
    if (params.actor != null)
      __params = __params.set('actor', params.actor.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/resourceType/${encodeURIComponent(
          String(params.resourceType),
        )}/resourceName/${encodeURIComponent(
          String(params.resourceName),
        )}/workflow-runs`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListWorkflowRunsResponse>;
      }),
    );
  }
  /**
   * getWorkflowRuns
   * @param params The `UiBlueprintDesignerControllerService.GetWorkflowRunsUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `workflowId`: workflowId
   *
   * - `status`: status
   *
   * - `pageSize`: pageSize
   *
   * - `pageNumber`: pageNumber
   *
   * - `event`: event
   *
   * - `branch`: branch
   *
   * - `actor`: actor
   *
   * @return OK
   */
  getWorkflowRunsUsingGET(
    params: UiBlueprintDesignerControllerService.GetWorkflowRunsUsingGETParams,
  ): __Observable<ListWorkflowRunsResponse> {
    return this.getWorkflowRunsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as ListWorkflowRunsResponse),
    );
  }

  /**
   * getWorkflows
   * @param params The `UiBlueprintDesignerControllerService.GetWorkflowsUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * @return OK
   */
  getWorkflowsUsingGETResponse(
    params: UiBlueprintDesignerControllerService.GetWorkflowsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<Workflow>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/resourceType/${encodeURIComponent(
          String(params.resourceType),
        )}/resourceName/${encodeURIComponent(
          String(params.resourceName),
        )}/workflows`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Workflow>>;
      }),
    );
  }
  /**
   * getWorkflows
   * @param params The `UiBlueprintDesignerControllerService.GetWorkflowsUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * @return OK
   */
  getWorkflowsUsingGET(
    params: UiBlueprintDesignerControllerService.GetWorkflowsUsingGETParams,
  ): __Observable<Array<Workflow>> {
    return this.getWorkflowsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<Workflow>),
    );
  }

  /**
   * addVariables
   * @param params The `UiBlueprintDesignerControllerService.AddVariablesUsingPOSTParams` containing the following parameters:
   *
   * - `variables`: variables
   *
   * - `stackName`: stackName
   */
  addVariablesUsingPOSTResponse(
    params: UiBlueprintDesignerControllerService.AddVariablesUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.variables;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/variables`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * addVariables
   * @param params The `UiBlueprintDesignerControllerService.AddVariablesUsingPOSTParams` containing the following parameters:
   *
   * - `variables`: variables
   *
   * - `stackName`: stackName
   */
  addVariablesUsingPOST(
    params: UiBlueprintDesignerControllerService.AddVariablesUsingPOSTParams,
  ): __Observable<null> {
    return this.addVariablesUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * updateVariables
   * @param params The `UiBlueprintDesignerControllerService.UpdateVariablesUsingPUTParams` containing the following parameters:
   *
   * - `variables`: variables
   *
   * - `stackName`: stackName
   */
  updateVariablesUsingPUTResponse(
    params: UiBlueprintDesignerControllerService.UpdateVariablesUsingPUTParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.variables;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/variables`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * updateVariables
   * @param params The `UiBlueprintDesignerControllerService.UpdateVariablesUsingPUTParams` containing the following parameters:
   *
   * - `variables`: variables
   *
   * - `stackName`: stackName
   */
  updateVariablesUsingPUT(
    params: UiBlueprintDesignerControllerService.UpdateVariablesUsingPUTParams,
  ): __Observable<null> {
    return this.updateVariablesUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * deleteVariables
   * @param params The `UiBlueprintDesignerControllerService.DeleteVariablesUsingDELETEParams` containing the following parameters:
   *
   * - `variables`: variables
   *
   * - `stackName`: stackName
   */
  deleteVariablesUsingDELETEResponse(
    params: UiBlueprintDesignerControllerService.DeleteVariablesUsingDELETEParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.variables;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/variables`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * deleteVariables
   * @param params The `UiBlueprintDesignerControllerService.DeleteVariablesUsingDELETEParams` containing the following parameters:
   *
   * - `variables`: variables
   *
   * - `stackName`: stackName
   */
  deleteVariablesUsingDELETE(
    params: UiBlueprintDesignerControllerService.DeleteVariablesUsingDELETEParams,
  ): __Observable<null> {
    return this.deleteVariablesUsingDELETEResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * getWorkflowRuns
   * @param params The `UiBlueprintDesignerControllerService.GetWorkflowRunsUsingGET1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `workflowId`: workflowId
   *
   * - `status`: status
   *
   * - `pageSize`: pageSize
   *
   * - `pageNumber`: pageNumber
   *
   * - `event`: event
   *
   * - `branch`: branch
   *
   * - `actor`: actor
   *
   * @return OK
   */
  getWorkflowRunsUsingGET1Response(
    params: UiBlueprintDesignerControllerService.GetWorkflowRunsUsingGET1Params,
  ): __Observable<__StrictHttpResponse<ListWorkflowRunsResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.workflowId != null)
      __params = __params.set('workflowId', params.workflowId.toString());
    if (params.status != null)
      __params = __params.set('status', params.status.toString());
    if (params.pageSize != null)
      __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set('pageNumber', params.pageNumber.toString());
    if (params.event != null)
      __params = __params.set('event', params.event.toString());
    if (params.branch != null)
      __params = __params.set('branch', params.branch.toString());
    if (params.actor != null)
      __params = __params.set('actor', params.actor.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/workflow-runs`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListWorkflowRunsResponse>;
      }),
    );
  }
  /**
   * getWorkflowRuns
   * @param params The `UiBlueprintDesignerControllerService.GetWorkflowRunsUsingGET1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `workflowId`: workflowId
   *
   * - `status`: status
   *
   * - `pageSize`: pageSize
   *
   * - `pageNumber`: pageNumber
   *
   * - `event`: event
   *
   * - `branch`: branch
   *
   * - `actor`: actor
   *
   * @return OK
   */
  getWorkflowRunsUsingGET1(
    params: UiBlueprintDesignerControllerService.GetWorkflowRunsUsingGET1Params,
  ): __Observable<ListWorkflowRunsResponse> {
    return this.getWorkflowRunsUsingGET1Response(params).pipe(
      __map((_r) => _r.body as ListWorkflowRunsResponse),
    );
  }

  /**
   * getWorkflows
   * @param stackName stackName
   * @return OK
   */
  getWorkflowsUsingGET1Response(
    stackName: string,
  ): __Observable<__StrictHttpResponse<Array<Workflow>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(String(stackName))}/workflows`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Workflow>>;
      }),
    );
  }
  /**
   * getWorkflows
   * @param stackName stackName
   * @return OK
   */
  getWorkflowsUsingGET1(stackName: string): __Observable<Array<Workflow>> {
    return this.getWorkflowsUsingGET1Response(stackName).pipe(
      __map((_r) => _r.body as Array<Workflow>),
    );
  }

  /**
   * getDesignerResources
   * @param params The `UiBlueprintDesignerControllerService.GetDesignerResourcesUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `branchName`: branchName
   *
   * @return OK
   */
  getDesignerResourcesUsingGETResponse(
    params: UiBlueprintDesignerControllerService.GetDesignerResourcesUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<BlueprintFile>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/${encodeURIComponent(String(params.branchName))}/files`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<BlueprintFile>>;
      }),
    );
  }
  /**
   * getDesignerResources
   * @param params The `UiBlueprintDesignerControllerService.GetDesignerResourcesUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `branchName`: branchName
   *
   * @return OK
   */
  getDesignerResourcesUsingGET(
    params: UiBlueprintDesignerControllerService.GetDesignerResourcesUsingGETParams,
  ): __Observable<Array<BlueprintFile>> {
    return this.getDesignerResourcesUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<BlueprintFile>),
    );
  }

  /**
   * createBranch
   * @param params The `UiBlueprintDesignerControllerService.CreateBranchUsingPOSTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `branch`: branch
   */
  createBranchUsingPOSTResponse(
    params: UiBlueprintDesignerControllerService.CreateBranchUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/${encodeURIComponent(String(params.branch))}/create-branch`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * createBranch
   * @param params The `UiBlueprintDesignerControllerService.CreateBranchUsingPOSTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `branch`: branch
   */
  createBranchUsingPOST(
    params: UiBlueprintDesignerControllerService.CreateBranchUsingPOSTParams,
  ): __Observable<null> {
    return this.createBranchUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * applyTemplate
   * @param params The `UiBlueprintDesignerControllerService.ApplyTemplateUsingPOSTParams` containing the following parameters:
   *
   * - `templateName`: templateName
   *
   * - `stackName`: stackName
   *
   * - `suffix`: suffix
   *
   * - `prefix`: prefix
   */
  applyTemplateUsingPOSTResponse(
    params: UiBlueprintDesignerControllerService.ApplyTemplateUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.suffix != null)
      __params = __params.set('suffix', params.suffix.toString());
    if (params.prefix != null)
      __params = __params.set('prefix', params.prefix.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.stackName),
        )}/${encodeURIComponent(String(params.templateName))}/apply`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * applyTemplate
   * @param params The `UiBlueprintDesignerControllerService.ApplyTemplateUsingPOSTParams` containing the following parameters:
   *
   * - `templateName`: templateName
   *
   * - `stackName`: stackName
   *
   * - `suffix`: suffix
   *
   * - `prefix`: prefix
   */
  applyTemplateUsingPOST(
    params: UiBlueprintDesignerControllerService.ApplyTemplateUsingPOSTParams,
  ): __Observable<null> {
    return this.applyTemplateUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * syncSpecifiedBlueprintsWithTemplates
   * @param params The `UiBlueprintDesignerControllerService.SyncSpecifiedBlueprintsWithTemplatesUsingPOSTParams` containing the following parameters:
   *
   * - `templateName`: templateName
   *
   * - `blueprintNames`: blueprintNames
   */
  syncSpecifiedBlueprintsWithTemplatesUsingPOSTResponse(
    params: UiBlueprintDesignerControllerService.SyncSpecifiedBlueprintsWithTemplatesUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.blueprintNames;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/designer/${encodeURIComponent(
          String(params.templateName),
        )}/sync`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * syncSpecifiedBlueprintsWithTemplates
   * @param params The `UiBlueprintDesignerControllerService.SyncSpecifiedBlueprintsWithTemplatesUsingPOSTParams` containing the following parameters:
   *
   * - `templateName`: templateName
   *
   * - `blueprintNames`: blueprintNames
   */
  syncSpecifiedBlueprintsWithTemplatesUsingPOST(
    params: UiBlueprintDesignerControllerService.SyncSpecifiedBlueprintsWithTemplatesUsingPOSTParams,
  ): __Observable<null> {
    return this.syncSpecifiedBlueprintsWithTemplatesUsingPOSTResponse(
      params,
    ).pipe(__map((_r) => _r.body as null));
  }
}

module UiBlueprintDesignerControllerService {
  /**
   * Parameters for createResourcesUsingPOST
   */
  export interface CreateResourcesUsingPOSTParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceFileRequests
     */
    resourceFileRequests: Array<ResourceFileRequest>;

    /**
     * branch
     */
    branch: string;
  }

  /**
   * Parameters for updateResourcesUsingPUT
   */
  export interface UpdateResourcesUsingPUTParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceFileRequests
     */
    resourceFileRequests: Array<ResourceFileRequest>;

    /**
     * branch
     */
    branch: string;
  }

  /**
   * Parameters for deleteResourcesUsingDELETE
   */
  export interface DeleteResourcesUsingDELETEParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceFileRequests
     */
    resourceFileRequests: Array<ResourceFileRequest>;

    /**
     * branch
     */
    branch: string;
  }

  /**
   * Parameters for renameResourceUsingPUT
   */
  export interface RenameResourceUsingPUTParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceRenameRequest
     */
    resourceRenameRequest: ResourceRenameRequest;

    /**
     * branch
     */
    branch: string;
  }

  /**
   * Parameters for bulkEditDisabledForResourcesUsingPUT
   */
  export interface BulkEditDisabledForResourcesUsingPUTParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceEnableDisableRequestList
     */
    resourceEnableDisableRequestList: Array<ResourceEnableDisableRequest>;

    /**
     * branch
     */
    branch: string;
  }

  /**
   * Parameters for getModuleInputsUsingGET
   */
  export interface GetModuleInputsUsingGETParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * intent
     */
    intent: string;

    /**
     * flavor
     */
    flavor: string;
  }

  /**
   * Parameters for getPullRequestsUsingGET
   */
  export interface GetPullRequestsUsingGETParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * state
     */
    state?: 'OPEN' | 'CLOSED' | 'ALL';

    /**
     * query
     */
    query?: string;

    /**
     * pageSize
     */
    pageSize?: number;

    /**
     * pageNumber
     */
    pageNumber?: number;

    /**
     * createdDate
     */
    createdDate?: string;
  }

  /**
   * Parameters for bulkEditDisabledForResourcesUsingPUT1
   */
  export interface BulkEditDisabledForResourcesUsingPUT1Params {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceEnableDisableRequestList
     */
    resourceEnableDisableRequestList: Array<ResourceEnableDisableRequest>;
  }

  /**
   * Parameters for getAddOnModulesUsingGET
   */
  export interface GetAddOnModulesUsingGETParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;

    /**
     * cloud
     */
    cloud?: string;
  }

  /**
   * Parameters for listBranchesUsingGET1
   */
  export interface ListBranchesUsingGET1Params {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;
  }

  /**
   * Parameters for getPullRequestsUsingGET1
   */
  export interface GetPullRequestsUsingGET1Params {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;

    /**
     * state
     */
    state?: 'OPEN' | 'CLOSED' | 'ALL';

    /**
     * query
     */
    query?: string;

    /**
     * pageSize
     */
    pageSize?: number;

    /**
     * pageNumber
     */
    pageNumber?: number;

    /**
     * createdDate
     */
    createdDate?: string;
  }

  /**
   * Parameters for getWorkflowRunsUsingGET
   */
  export interface GetWorkflowRunsUsingGETParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;

    /**
     * workflowId
     */
    workflowId?: string;

    /**
     * status
     */
    status?: string;

    /**
     * pageSize
     */
    pageSize?: number;

    /**
     * pageNumber
     */
    pageNumber?: number;

    /**
     * event
     */
    event?: string;

    /**
     * branch
     */
    branch?: string;

    /**
     * actor
     */
    actor?: string;
  }

  /**
   * Parameters for getWorkflowsUsingGET
   */
  export interface GetWorkflowsUsingGETParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;
  }

  /**
   * Parameters for addVariablesUsingPOST
   */
  export interface AddVariablesUsingPOSTParams {
    /**
     * variables
     */
    variables: { [key: string]: VariableDetails };

    /**
     * stackName
     */
    stackName: string;
  }

  /**
   * Parameters for updateVariablesUsingPUT
   */
  export interface UpdateVariablesUsingPUTParams {
    /**
     * variables
     */
    variables: { [key: string]: VariableDetails };

    /**
     * stackName
     */
    stackName: string;
  }

  /**
   * Parameters for deleteVariablesUsingDELETE
   */
  export interface DeleteVariablesUsingDELETEParams {
    /**
     * variables
     */
    variables: Array<string>;

    /**
     * stackName
     */
    stackName: string;
  }

  /**
   * Parameters for getWorkflowRunsUsingGET1
   */
  export interface GetWorkflowRunsUsingGET1Params {
    /**
     * stackName
     */
    stackName: string;

    /**
     * workflowId
     */
    workflowId?: string;

    /**
     * status
     */
    status?: string;

    /**
     * pageSize
     */
    pageSize?: number;

    /**
     * pageNumber
     */
    pageNumber?: number;

    /**
     * event
     */
    event?: string;

    /**
     * branch
     */
    branch?: string;

    /**
     * actor
     */
    actor?: string;
  }

  /**
   * Parameters for getDesignerResourcesUsingGET
   */
  export interface GetDesignerResourcesUsingGETParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * branchName
     */
    branchName: string;
  }

  /**
   * Parameters for createBranchUsingPOST
   */
  export interface CreateBranchUsingPOSTParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * branch
     */
    branch: string;
  }

  /**
   * Parameters for applyTemplateUsingPOST
   */
  export interface ApplyTemplateUsingPOSTParams {
    /**
     * templateName
     */
    templateName: string;

    /**
     * stackName
     */
    stackName: string;

    /**
     * suffix
     */
    suffix?: string;

    /**
     * prefix
     */
    prefix?: string;
  }

  /**
   * Parameters for syncSpecifiedBlueprintsWithTemplatesUsingPOST
   */
  export interface SyncSpecifiedBlueprintsWithTemplatesUsingPOSTParams {
    /**
     * templateName
     */
    templateName: string;

    /**
     * blueprintNames
     */
    blueprintNames: Array<string>;
  }
}

export { UiBlueprintDesignerControllerService };
